import { render } from "./DraftBookingFlow_treatment_category_first.vue?vue&type=template&id=78bf6f98&scoped=true"
import script from "./DraftBookingFlow_treatment_category_first.vue?vue&type=script&lang=js"
export * from "./DraftBookingFlow_treatment_category_first.vue?vue&type=script&lang=js"

import "./DraftBookingFlow_treatment_category_first.vue?vue&type=style&index=0&id=78bf6f98&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-78bf6f98"]])

export default __exports__